; (function () {


    var SearchAvailableAppointmentSlotsFormat1Routes = [
        {
            "name": "Select_Physician_or_Provider_or_Resources",
            "templateUrl": "AngularScripts/SelectPhysician/Htmls/SelectPhysician.html",
            "RoutingNumber": 73,
            files: [
                "AngularScripts/SelectPhysician/Services/SelectPhysicianControllerService.js",
                "AngularScripts/SelectPhysician/Controllers/SelectPhysicianController.js"
            ]
        },
    ];



    angular.module('EMR.SelectPhysicianPopUpModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(SearchAvailableAppointmentSlotsFormat1Routes, $stateProvider);
            }]);
})();